import React from 'react'
import { IProps } from './index'
import classNames from 'classnames'

export const SwitcheableContent: React.FC<IProps> = ({ experience, childA, childB }) => {
  const getViewClasses = (expectedExp: string) =>
    classNames('switchable-content__view', {
      'switchable-content__view--hide': experience !== expectedExp,
    })
  return (
    <>
      <div className="switchable-content">
        <div className={getViewClasses('A')} role="listitem">
          {childA}
        </div>
        <div className={getViewClasses('B')} role="listitem">
          {childB}
        </div>
      </div>
      <style jsx>{`
        .switchable-content {
          display: grid;
          grid-template-columns: 1fr;
          overflow: hidden;
        }

        .switchable-content__view {
          grid-row-start: 1;
          grid-column-start: 1;
          transition: opacity 1s;
          visibilty: visible;
          opacity: 1;

          &--hide {
            opacity: 0;
            animation-name: switcheable-content-fade-out;
            animation-delay: 800ms;
            animation-duration: 1ms;
            animation-fill-mode: forwards;
          }
        }

        @keyframes switcheable-content-fade-out {
          from {
            visibility: visible;
          }
          to {
            visibility: hidden;
          }
        }
      `}</style>
    </>
  )
}
